import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import GithubCodeScanConfigListing from './GithubCodeScanConfigListing';
import GithubCodeScanCredentialsForm from './GithubCodeScanCredentialsForm';

const GithubCodeScanPullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={GithubCodeScanCredentialsForm}
        PullConfigListingView={GithubCodeScanConfigListing}
     />
);

export default GithubCodeScanPullAndPushView;
